/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_FailedInputs */

const en_us2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't check right now. Check your connection and try again.`)
};

const pt_br2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para procurar agora. Confira a internet e tente de novo.`)
};

const es_419_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo buscar ahora. Revisa tu conexión e inténtalo de nuevo.`)
};

const pt_pt2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível procurar agora. Verifica a ligação e tenta outra vez.`)
};

const fr_fr2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de vérifier pour l'instant. Vérifie ta connexion et réessaie.`)
};

const de_de2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche gerade nicht möglich. Prüf deine Verbindung und versuch es noch mal.`)
};

const it_it2_profile_update_failed = /** @type {(inputs: Profile_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile controllare ora. Verifica la connessione e riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't check right now. Check your connection and try again." |
*
* @param {Profile_Update_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_failed = /** @type {((inputs?: Profile_Update_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_failed(inputs)
	if (locale === "es-419") return es_419_profile_update_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_failed(inputs)
	if (locale === "de-DE") return de_de2_profile_update_failed(inputs)
	if (locale === "it-IT") return it_it2_profile_update_failed(inputs)
	return en_us2_profile_update_failed(inputs)
});
export { profile_update_failed as "profile.update_failed" }